import { tv } from 'tailwind-variants';

export const tableRecipe = tv({
  slots: {
    container: '',
    table: 'table-auto !border-collapse !m-0',
    header: '',
    row: `
      border-b border-brand-border
      last:border-b-0
    `,
    head: [
      'font-semibold text-brand-text-secondary text-left py-2 px-1.5 text-sm cursor-pointer',
      'border-b border-brand-border !normal-case !tracking-normal select-none',
    ],
    cell: `
      bg-brand-background px-1.5 py-2 align-top text-sm text-brand-text
      data-[selected=true]:bg-c-surface-selected
    `,
    paginationContainer: `
      flex items-center justify-between border-t border-brand-border px-2 py-1.5
    `,
  },
  variants: {
    variant: {
      default: {
        container: `
          relative flex w-full flex-col rounded-lg border border-brand-border
          bg-brand-background
        `,
        head: ['first:rounded-tl-lg', 'last:rounded-tr-lg'],
        paginationContainer: 'rounded-b-lg',
      },
      flat: {
        container: 'relative flex w-full flex-col bg-brand-background',
      },
    },
    variantBg: {
      surface: {
        header: 'bg-brand-surface-secondary',
        paginationContainer: 'bg-brand-surface-secondary',
        head: 'bg-brand-surface-secondary',
      },
      unstyled: {
        header: '',
        paginationContainer: '',
      },
    },
    isHoverable: {
      true: {
        row: 'group',
        cell: 'group-hover:bg-c-surface-hover',
      },
      false: {},
    },
  },
  defaultVariants: {
    variantBg: 'surface',
    variant: 'default',
    isHoverable: false,
  },
});

/**
 * @typedef {import('tailwind-variants').VariantProps<typeof tableRecipe>} TableRecipeVariants
 */
